import { NgModule, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TsSearchComponent } from './ts-search.component';
import { DestinationPickerComponent } from './sub-components/destination-picker/destination-picker.component';
import { AirportPickerComponent } from './sub-components/airport-picker/airport-picker.component';
import { PartySizePickerComponent } from './sub-components/party-size-picker/party-size-picker.component';
import { DatePickerComponent } from './sub-components/date-picker/date-picker.component';
import { DirectivesModule } from '../../directives/directives.module';
import { SearchService } from '../../services/search.service';
import { APIService } from '../../services/api.service';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { StickyHeaderComponent } from './sub-components/sticky-header/sticky-header.component';
import { DatePipe } from '../../pipes/date-format';
import { TsSpinnerSVGModule } from '../ts-spinner-svg/ts-spinner-svg.module';

@NgModule({
  imports: [
    CommonModule, DirectivesModule, HttpClientModule, ReactiveFormsModule, FormsModule, TsSpinnerSVGModule
  ],
  declarations: [TsSearchComponent, DestinationPickerComponent, AirportPickerComponent, PartySizePickerComponent, DatePickerComponent, DatePipe, StickyHeaderComponent],
  exports: [
    TsSearchComponent,
    DatePipe
  ],
  providers: [SearchService, APIService],
  entryComponents: [TsSearchComponent]
})
export class TsSearchModule {
  constructor(private injector: Injector) {
  }
  ngDoBootstrap() { }
}
